import { useQuery } from "@tanstack/react-query"

import {
  type Mart,
  type MartPreset,
  type MartPresetConfig,
  type MartsPresetMetadata,
} from "@tokenterminal/tt-analytics-api-types/dist/api/marts"
import { apiGET } from "data/api/get"

export type MartPayloadData = Mart & {
  presets: Array<MartsPresetMetadata>
  default_preset:
    | (MartPreset & {
        config: Omit<MartPresetConfig["config"], "columns"> & {
          columns: {
            hide: boolean
            colId: string
            pivot: boolean
            width: number
            rowGroup: boolean
            sort?: "asc" | "desc"
            sortIndex?: number
          }[]
        }
      })
    | null
  column_definitions: Array<{
    cell_data_type: string | null
    col_id: string
    column_index: number
    enable_row_group: boolean
    enable_value_row: boolean
    field: string | null
    header_name: string
    header_tooltip: string | null
    parent: string | null
    sortable: boolean
  }>
}

export const useMart = (mart: string, isSlug: boolean = true) => {
  const { data, ...rest } = useQuery({
    queryKey: ["mart", mart, isSlug],
    queryFn: () =>
      apiGET(
        `/v2/internal/marts/${mart}${isSlug ? "?param=slug" : ""}` as `/v2/internal/marts/:slug`
      ),
    enabled: !!mart,
  })

  return {
    data: data ? (data.data as MartPayloadData) : null,
    ...rest,
  }
}
